<script>
	export let html;
</script>

<div class="tabs">
	{@html html.fixImageAndApiLinkPath()}
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	/* TODO: choose other than "tabs" */
	.tabs {
		.tabs {
			margin: 0 var(--spacing-mobile) var(--spacing-mobile) var(--spacing-mobile);
			
			h2, p {
				margin-bottom: calc(var(--spacing-mobile) / 2);
			}
			
			.tabs-container {
				margin-top: var(--spacing-mobile);
				
				input {
					display: none;
				}
				
				.tabs {
					display: flex;
					flex-direction: row;
					width: 100%;
					margin: 0;
					
					label {
						flex: auto;
						@include font-px-to-rem(35, 55, 600);
						padding: calc(var(--spacing-mobile) / 3) calc(var(--spacing-mobile) / 2);
					}
				}
				
				.bg_black {
					background-color: black;
					color: white;
				}
				
				.bg_gray {
					background-color: gray;
					color: white;
				}
				
				.bg_lightgray {
					background-color: lightgray;
					color: white;
				}
				
				input + div {
					display: none;
					padding: var(--spacing-mobile) calc(var(--spacing-mobile) / 2);
				}
				
				input:checked + div {
					display: inline-block;
				}
			}
		}
	}
</style>
